import { requestOrThrow } from '../api-client'
import type { Booking } from '../booking'

// チェックイン実行。リクエストボディは無く、応答は予約詳細と同型。
// 失敗時は 400 {message, code} が返り、code(E001/E002/E003/E004)で呼び出し側が表示を分ける。
export function checkinBooking(id: number, targetGroupMemberId?: number) {
  return requestOrThrow<Booking>(`events/${id}/checkin`, {
    method: 'POST',
    // 代理予約の宛先。既存の他APIと同じ指定で足りる。未指定=操作者自身。
    query: targetGroupMemberId != null ? { targetGroupMemberId } : {},
  })
}
